import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * Ação secundária padrão para fechar modais. Centraliza tamanho, ícone e
 * comportamento visual para evitar variações entre telas e temas.
 */
const ModalCloseButton = ({ children, className = '', ...props }) => {
    const { t } = useTranslation();

    return (
        <Button
            type="button"
            variant=""
            className={`colmeia-modal-close-button ${className}`.trim()}
            {...props}
        >
            <i className="fas fa-xmark me-2" aria-hidden="true"></i>
            {children || t('close')}
        </Button>
    );
};

export default ModalCloseButton;
